import { COLORS } from '@alto/design-library-tokens';
import { Row } from '@alto/design-system';
import React from 'react';
import styled from 'styled-components';

export type Props = {
  readonly totalSteps: number;
  readonly currentIndex: number;
};

const Step = styled.div<{ highlighted: boolean }>`
  background-color: ${(props) =>
    props.highlighted ? COLORS.BACKGROUND_COLORS.SUCCESS : COLORS.BACKGROUND_COLORS.GREY};
  flex-grow: 1;
  height: 4px;
  margin: 2px;
`;

export const ProgressIndicator: React.FC<Props> = ({ totalSteps, currentIndex }) => {
  const steps = Array.from(
    {
      length: totalSteps,
    },
    (_, k) => k + 1,
  ).map((s, i) => {
    return (
      <Step
        key={`progress-indicator-step-${s}`}
        highlighted={i <= currentIndex}
      />
    );
  });

  return <Row>{steps}</Row>;
};
